import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";

import IconSaved from "assets/svg/icon_save.svg";

import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import ModalTextContent from "components/modal-text-content";
import ShowcaseForm from "components/listing-search/save-search-form";
import LoginForm from "components/login/forms/login";
import ForgotPasswordForm from "components/login/forgot-password-form";
import Modal from "components/common/modal";

import styles from "./styles.module.css";

const SaveTheSearchButton = ({ name, urlPath }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [forgotFormMail, setForgotFormMail] = useState("");
  const [isLogin, setIsLogin] = useState(false);
  const [isForgotPasswordForm, setIsForgotPasswordForm] = useState(false);

  const handleForgotButton = () => {
    setIsForgotPasswordForm(!isForgotPasswordForm);
  };

  useEffect(() => {
    const mail = localStorage.getItem("forgot-password-user");
    setForgotFormMail(mail);
    const isLogin = localStorage.getItem("user-data");
    setIsLogin(isLogin);
  }, []);

  const handleModalClose = () => {
    setIsForgotPasswordForm(false);
    setIsModalOpen(false);
  };

  const handleModalOpen = () => {
    setIsModalOpen(true);
    Ga4WithEventParameters({
      eventName: "click_button",
      eventParameters: { label: "aramayi-kaydet" },
    });
  };

  const renderModal = () => {
    if (!isLogin) {
      return (
        <ModalTextContent>
          {!isForgotPasswordForm ? (
            <LoginForm modal handleForgotButton={handleForgotButton} successCallback={() => setIsLogin(true)} />
          ) : (
            <ForgotPasswordForm modal defaultMail={forgotFormMail} handleBackButtonForgotForm={handleForgotButton} />
          )}
        </ModalTextContent>
      );
    } else {
      return (
        <ModalTextContent>
          <ShowcaseForm name={name} urlPath={urlPath} />
        </ModalTextContent>
      );
    }
  };

  return (
    <>
      <button onClick={handleModalOpen} className={styles.savedButton}>
        <IconSaved className={styles.icon} />
        Aramayı Kaydet
      </button>
      <Modal isOpen={isModalOpen} handleClose={() => handleModalClose()}>
        {renderModal()}
      </Modal>
    </>
  );
};

SaveTheSearchButton.propTypes = {
  name: PropTypes.string,
  urlPath: PropTypes.string,
};

export default SaveTheSearchButton;
